// Extracted from Dashboard/index.web.jsx on 2026-10-02.
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  DEFAULT_LOCATION,
  LOCATION_PERMISSION_DISABLED_MESSAGE,
} from 'config/defaultLocation.config';
import type { EffectiveLocationSource } from 'hooks/useLocation';

const useDashboardLocationNotice = (locationSource: EffectiveLocationSource) => {
  const [locationPermissionNotice, setLocationPermissionNotice] = useState('');
  useEffect(() => {
    const defaultLocationText = `${DEFAULT_LOCATION.label} (${DEFAULT_LOCATION.latitude}, ${DEFAULT_LOCATION.longitude})`;
    const deniedNotice = `${LOCATION_PERMISSION_DISABLED_MESSAGE} Default location: ${defaultLocationText}.`;
    let isMounted = true;
    let permissionStatus: PermissionStatus | null = null;

    const updateNotice = (state: PermissionState | 'unavailable' | 'unknown') => {
      if (!isMounted) return;

      if (state === 'denied' || state === 'unavailable') {
        setLocationPermissionNotice(deniedNotice);
        return;
      }

      if (state === 'granted') {
        setLocationPermissionNotice('');
        return;
      }

      if (locationSource === 'default') {
        setLocationPermissionNotice(
          `Using default location ${defaultLocationText} until browser location is available.`,
        );
      } else {
        setLocationPermissionNotice('');
      }
    };

    if (!navigator?.geolocation) {
      updateNotice('unavailable');
      return () => {
        isMounted = false;
      };
    }

    if (!navigator.permissions?.query) {
      updateNotice('unknown');
      return () => {
        isMounted = false;
      };
    }

    navigator.permissions
      .query({ name: 'geolocation' })
      .then((result) => {
        if (!isMounted) return;
        permissionStatus = result;
        updateNotice(result.state);
        permissionStatus.onchange = () => updateNotice(permissionStatus.state);
      })
      .catch(() => {
        updateNotice('unknown');
      });

    return () => {
      isMounted = false;
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, [locationSource]);

  useEffect(() => {
    if (locationPermissionNotice) {
      toast.success(locationPermissionNotice);
    }
  }, [locationPermissionNotice]);
};

export default useDashboardLocationNotice;
